



















import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    switchId: { type: String },
    label: { type: String },
    labelOn: { type: String },
    labelOff: { type: String },
    checked: { type: Boolean },
    handleChange: { type: Function },
    containerClass: { type: String, default: '' },
    customAttrs: { type: Object }
  }
})
export default class FormInput extends Vue {}
